import $$ from 'cmn-utils'
const BaseUrl = "/api/safety/position/template/";
export default {
    list: (params) => {
        return $$.get(BaseUrl + `list`, params);
    },
    unSelectList: (params) => {
        return $$.get(BaseUrl + `un-select-list`, params);
    },
    create: (params) => {
        return $$.post(BaseUrl + `create`, params);
    },
    delete: (params) => {
        return $$.post(BaseUrl + `delete`, params);
    },
}